
import SceneObject from "../scene/sceneobject";
export default class SoundService 
{
    context:AudioContext;
    listener:SceneObject | null = null;
    
    constructor()
    {
        this.context  = new (window.AudioContext || (window as any).webkitAudioContext)();

    }

    //any SceneObject can be a listener
    set_listener(InListener:SceneObject):void
    {
        this.listener = InListener;
        this.tick_listener();
    }

     tick_listener()
     {
        if(this.listener)
        {
            const audio_listener: AudioListener = this.context.listener;
            audio_listener.positionX.setValueAtTime(this.listener.transform.position[0], this.context.currentTime);
            audio_listener.positionY.setValueAtTime(this.listener.transform.position[1], this.context.currentTime);
            audio_listener.positionZ.setValueAtTime(this.listener.transform.position[2], this.context.currentTime);
        }
     }

     tick(delta_time: number):void
     {
         this.tick_listener();
     }
}